<template>
	<header>
    <nav id="header" v-if="selectedBot">
      <ul class="nav left">
        <li class="divide-right">
          <router-link to="/allbots" class="navbar-brand" style="padding: 10px">
          <img :src="$store.state.theme.small_logo" alt="" style="max-height: 27px;" class="hidden-xs">
          <img :src="$store.state.theme.short_small_logo" alt="" style="max-height: 27px;" class="visible-xs">
          </router-link>
        </li>
        <li class="divide-right" v-if="botlist.length < 2">
          <a href="#" style="padding: 12px"><img class="current-bot-image" @error="onError" :src="'https://graph.facebook.com/'+ selectedBot.pageid +'/picture?width=100&height=100'" alt="Card image cap" style="border-radius: 50%;width:25px;height:25px;margin-right:5px;"> <span class="hidden-xs">{{ selectedBot.pagename }}</span> </a>
        </li>
        <!-- <li class="divide-right" class="hidden-xs"><router-link to="/allbots" class="navbar-brand"><span class="glyphicon glyphicon-th"></span></router-link></li> -->
        <li class="dropdown divide-right" v-else >
          <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" style="padding: 12px;"><img class="current-bot-image" @error="onError" :src="'https://graph.facebook.com/'+ selectedBot.pageid +'/picture?width=100&height=100'" alt="Card image cap" style="border-radius: 50%;width:25px;height:25px;margin-right:5px;"> <span class="hidden-xs">{{ selectedBot.pagename }}</span> <span class="caret" v-if="botlist.length > 1"></span></a>
          
          <ul class="dropdown-menu" v-if="selectedBot && botlist.length > 2" style="max-height: 300px;overflow-y: auto;">
            
                <li class="nav-img" v-for="(bot, bindex) in botlist" :key="'bot_'+bindex" v-if="bot.pageid != selectedBot.pageid" @click="selectedBot = bot"><a href="javascript:void(0);"><img class="current-bot-image" :src="'https://graph.facebook.com/'+ bot.pageid +'/picture?width=100&height=100'" alt="Card image cap" style="border-radius: 50%;width:45px;height:45px;margin-right:5px;" > <span class="truncate">{{ bot.pagename | truncate(20)}}</span></a></li>
            
          </ul>
        </li>
        <li class="text divide-right" :title="(selectedBot.status ? 'Active' : 'Inactive')">
          <span class="status" :class="{ 'glyphicon glyphicon-play start' : selectedBot.status , 'glyphicon glyphicon-pause stop' : !selectedBot.status}"></span> <span class="hidden-xs">{{ selectedBot.status ? 'Active' : 'Inactive' }}</span>
        </li>
        <li class="divide-right">
          <a :href="'https://m.me/'+selectedBot.pageid" target="blank" title="Test this Bot" v-if="selectedBot.status">
            <i class="fab fa-facebook-messenger"></i> <span class="hidden-xs">Test this Bot</span>
          </a>

          <a href="javascript:void(0)" v-else title="Test this Bot" class="disabled">
            <i class="fab fa-facebook-messenger"></i> <span class="hidden-xs">Test this Bot</span>
          </a>
        </li>
        <li>
          <router-link :to="'/chatbot?tab=livechat'" title="livechat" v-if="env !== 'production'">
            <i class="fas fa-comments"></i>
          </router-link>
        </li>
      </ul>

      <ul class="nav right" >
        <li class="dropdown divide-right" v-if="!$store.state.theme.hide_zwiz"><a href="javascript:void(0);"><span class="glyphicon glyphicon-question-sign"></span> <span class=" hidden-xs">Help</span> </a>
          <ul class="dropdown-menu dropdown-menu-right" v-if="selectedBot">
              <li><a href="https://blog.zwiz.ai/getstarted-zwizai/" target="blank">How to Use / วิธีการใช้งานเบื้องต้น</a></li>
              <li><a href="https://facebook.com/groups/zwizaigroup" target="blank">Join Community / เข้ากลุ่มเพื่อสอบถาม</a></li>
              <li><a :href="'mailto:' + $store.state.theme.email_contact">Contact Us: {{$store.state.theme.email_contact}}</a></li>
            </ul>
        </li>
        <li><a href="javascript:void(0);" @click="logout"><span class="glyphicon glyphicon-off"></span> <span class=" hidden-xs">Logout</span> </a></li>
      </ul>
    </nav>
	</header>
</template>

<style>
</style>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  data () {
    return {
      env: process.env.NODE_ENV
    }
  },
  mounted: function(){
    if (this.selectedBot == null) {
      this.$router.push("/allbots")
    }
    var width = window.innerWidth;
    if (width <= 768) {
      this.$store.state.openSidebar = false
    }
  },
  computed:{
     ...mapGetters({
        // selectedBot: 'selectedBot',
        isFacebook: 'isFacebook',
        botlist: 'botlist',
        isSelectedBot: 'isSelectedBot'
      }),
      selectedBot: {
        get () {
          if (this.$store.state.selectedBot == null) {
              return null
          }
          return this.$store.state.selectedBot
        },
        set (bot) {
          let vm = this
          vm.currentBot = bot
          vm.$store.dispatch('selectBot',vm.currentBot)
          location.reload()
        }
      }
  },
  methods: {
  	logout: function() {
  		 if (confirm("Do you want to logout?")) {
         var isFacebook = this.isFacebook
          this.$store.dispatch('logout',null).then();
          if (isFacebook) {
            this.$router.push('/login')
          } else {
            this.$router.push('/nigol')
          }
      } 
  	},
    selectBot: function(pageid,event) {
      this.$store.dispatch('selectBot',pageid)
    },
    openSidebar: function() {
      this.$store.dispatch('sidebar')
    },
    onError: function(){
      $(event.target).attr('src','/static/img/assets/livechat/profile.png')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/elements/header.vue